import React from 'react'
import { FixedMessage, GridDeprecated } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import EventRow from '../eventRow'
import STATICS from '../../statics'
import styles from './styles.scss'

const { Row, Column } = GridDeprecated
const cx = classnames.bind(styles)

interface CalendarTableProps {
  events: any[]
}

const CalendarTable = ({ events }: CalendarTableProps) => (
  <div className={cx('calendar-table-container')}>
    <Row className={cx('calendar-table-header', 'desktop-only')}>
      <Column
        medium={3}
        elmId='calendar_table_header_date'
        className={cx('calendar-table-header-column')}
      >
        {STATICS.HEADER_LABEL_DATES_TYPE}
      </Column>
      <Column
        medium={6}
        elmId='calendar_table_header_event_name'
        className={cx('calendar-table-header-column')}
      >
        {STATICS.HEADER_LABEL_EVENT_NAME}
      </Column>
      <Column
        medium={3}
        elmId='calendar_table_header_total'
        className={cx('calendar-table-header-column')}
      >
        {STATICS.HEADER_LABEL_ASSETS_TOTAL}
      </Column>
    </Row>
    <div data-elm-id='calendar_table_results'>
      {events.map((event, index) => (
        <EventRow event={event} index={index + 1} key={`event-${index}`} />
      ))}
    </div>
  </div>
)

const NoResults = () => (
  <FixedMessage
    isVisible
    elmId='calendar_table_no_results'
    isCloseable={false}
    role='error'
    showIcon
  >
    {STATICS.NO_EVENT_FOUND}
  </FixedMessage>
)

const CalendarResults = ({ events }: CalendarTableProps) => {
  const showResults = events && events.length > 0

  return (
    <div className={cx('u-mb-4')}>
      {showResults ? <CalendarTable events={events} /> : <NoResults />}
    </div>
  )
}

export default CalendarResults
